import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-mall-app-download",
  "use": "icon-soc-mall-app-download-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-mall-app-download\">\r\n<g fill=\"currentColor\">\r\n  <rect x=\"360\" y=\"120\" width=\"304\" height=\"560\" rx=\"48\" />\r\n  <rect x=\"400\" y=\"180\" width=\"224\" height=\"400\" rx=\"16\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"28\" />\r\n  <circle cx=\"512\" cy=\"620\" r=\"22\" />\r\n  <path d=\"M512 720v120M432 776l80 80 80-80\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"48\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-mall-app-download.svg
// module id = auQP
// module chunks = 477